export default "__VITE_ASSET__DXaSEoOR__"